import * as React from "react";
const SvgFtpConnector = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M4 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h5.175a1.975 1.975 0 0 1 1.4.575L12 6h8c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v10c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 20H4Zm0-2h16V8h-8.825l-2-2H4v12Z"
    />
    <path
      d="M6.788 10.023V15H5.763v-4.977h1.025Zm1.983 2.126v.8H6.508v-.8h2.263Zm.24-2.126v.804H6.507v-.804H9.01Zm3.187 0V15h-1.022v-4.977h1.022Zm1.531 0v.804H9.67v-.804h4.06Zm2.823 3.203h-1.268v-.8h1.268c.196 0 .355-.032.479-.095a.614.614 0 0 0 .27-.274 1.002 1.002 0 0 0 0-.807.69.69 0 0 0-.27-.307.886.886 0 0 0-.479-.116h-.913V15h-1.025v-4.977h1.938c.39 0 .723.071 1.001.212.28.14.495.332.643.578.148.246.222.527.222.844 0 .322-.074.6-.222.834a1.443 1.443 0 0 1-.643.544c-.278.127-.611.191-1.001.191Z"
    />
  </svg>
);
export default SvgFtpConnector;
